function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 13.94,
    height: 6.53,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.653
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 3.265
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6.53,
    width: 13.94,
    height: 7.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 10.42
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.3,
    width: 13.94,
    height: 9.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.397142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 19.19
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.08,
    width: 13.94,
    height: 10.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 29.13
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.18,
    width: 13.94,
    height: 10.14,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6900000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 39.25
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 44.32,
    width: 13.94,
    height: 10.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 49.785
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55.26,
    width: 13.94,
    height: 11.01,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.37625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 60.765
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.26,
    width: 13.94,
    height: 11.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8553846153846153
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 71.82000000000001
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.39,
    width: 13.94,
    height: 13.99,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 84.385
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.38,
    width: 13.94,
    height: 15.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 99.11
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.84,
    width: 13.94,
    height: 16,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 114.84
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.84,
    width: 13.94,
    height: 16.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 130.875
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.9,
    width: 13.94,
    height: 18.63,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 148.215
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 157.54,
    width: 13.94,
    height: 19.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 167.505
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 177.47,
    width: 13.94,
    height: 20.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 187.535
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 197.59,
    width: 13.94,
    height: 21.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 208.395
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.2,
    width: 13.94,
    height: 21.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 230.01999999999998
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.84,
    width: 13.94,
    height: 22.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 251.935
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 263.03,
    width: 13.94,
    height: 23.06,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 274.55999999999995
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 286.09,
    width: 13.94,
    height: 24.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 298.23999999999995
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 310.38,
    width: 13.94,
    height: 24.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 322.77
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.16,
    width: 13.94,
    height: 25.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 347.735
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.31,
    width: 13.94,
    height: 25.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 373.06
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 385.81,
    width: 13.94,
    height: 26.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 399.14
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 412.47,
    width: 13.94,
    height: 27.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 425.98
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 439.48,
    width: 13.94,
    height: 27.34,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 453.15000000000003
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 466.82,
    width: 13.94,
    height: 27.9,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.394
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 480.77
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 494.73,
    width: 13.94,
    height: 28.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 509.08000000000004
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 523.42,
    width: 13.94,
    height: 28.83,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 537.8349999999999
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 552.26,
    width: 13.94,
    height: 28.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 566.6949999999999
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 581.13,
    width: 13.94,
    height: 29.2,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 595.73
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.33,
    width: 13.94,
    height: 29.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 624.985
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 639.64,
    width: 13.94,
    height: 29.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.788
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 654.5749999999999
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 669.52,
    width: 13.94,
    height: 30.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9914285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.97,
    y: 684.76
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 0,
    width: 17.63,
    height: 24.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5185714285714282
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.755,
    y: 12.27
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.57,
    y: 0,
    width: 17.69,
    height: 24.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.527142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.415,
    y: 12.27
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.27,
    y: 0,
    width: 17.75,
    height: 24.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9583333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.145,
    y: 12.27
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.01,
    y: 0,
    width: 18.24,
    height: 24.54,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.13000000000001,
    y: 12.27
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.25,
    y: 0,
    width: 18.53,
    height: 24.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6471428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 94.515,
    y: 12.27
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.79,
    y: 0,
    width: 18.62,
    height: 24.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.724
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.10000000000001,
    y: 12.27
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.41,
    y: 0,
    width: 18.64,
    height: 24.54,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.73,
    y: 12.27
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.05,
    y: 0,
    width: 19.05,
    height: 24.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 150.57500000000002,
    y: 12.27
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.1,
    y: 0,
    width: 20.09,
    height: 24.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.348333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.14499999999998,
    y: 12.27
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.19,
    y: 0,
    width: 20.72,
    height: 24.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.55,
    y: 12.27
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.9,
    y: 0,
    width: 21.54,
    height: 24.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.308
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 211.67000000000002,
    y: 12.27
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.44,
    y: 0,
    width: 22.6,
    height: 24.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.74,
    y: 12.27
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.05,
    y: 0,
    width: 22.8,
    height: 24.54,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.45,
    y: 12.27
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.85,
    y: 0,
    width: 23.06,
    height: 24.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.306
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.38,
    y: 12.27
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.91,
    y: 0,
    width: 24.37,
    height: 24.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.095,
    y: 12.27
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.27,
    y: 0,
    width: 26.21,
    height: 24.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.375,
    y: 12.27
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.49,
    y: 0,
    width: 26.47,
    height: 24.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.505714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.725,
    y: 12.27
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.96,
    y: 0,
    width: 26.74,
    height: 24.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.33,
    y: 12.27
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.7,
    y: 0,
    width: 28.1,
    height: 24.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.75,
    y: 12.27
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.8,
    y: 0,
    width: 28.36,
    height: 24.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.98,
    y: 12.27
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.16,
    y: 0,
    width: 29.74,
    height: 24.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.03000000000003,
    y: 12.27
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 480.9,
    y: 0,
    width: 30.51,
    height: 24.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.155,
    y: 12.27
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.4,
    y: 0,
    width: 30.54,
    height: 24.54,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.67,
    y: 12.27
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.94,
    y: 0,
    width: 30.92,
    height: 24.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.505714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 557.4000000000001,
    y: 12.27
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.87,
    y: 0,
    width: 30.94,
    height: 24.54,
    style: {
      fill: "#4C0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.34,
    y: 12.27
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.81,
    y: 0,
    width: 31.86,
    height: 24.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.7399999999999,
    y: 12.27
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.67,
    y: 0,
    width: 32.09,
    height: 24.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.7149999999999,
    y: 12.27
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.77,
    y: 0,
    width: 32.23,
    height: 24.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.885,
    y: 12.27
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 24.54,
    width: 31.29,
    height: 25.49,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.549
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 37.285
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 50.03,
    width: 31.29,
    height: 25.64,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.205
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 62.85
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 75.67,
    width: 31.29,
    height: 26.28,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 88.81
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 101.95,
    width: 31.29,
    height: 27.58,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.516
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 115.74000000000001
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 129.53,
    width: 31.29,
    height: 28.07,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.50875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 143.565
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 157.6,
    width: 31.29,
    height: 28.33,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6659999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 171.765
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 185.93,
    width: 31.29,
    height: 28.34,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.723333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 200.1
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 214.27,
    width: 31.29,
    height: 28.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 228.64000000000001
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 243.01,
    width: 31.29,
    height: 29.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.816
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 257.55
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 272.09,
    width: 31.29,
    height: 29.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9690000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 286.935
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 301.79,
    width: 31.29,
    height: 29.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 316.68
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 331.56,
    width: 31.29,
    height: 29.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.997999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 346.555
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 361.55,
    width: 31.29,
    height: 31.49,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 377.295
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 393.04,
    width: 31.29,
    height: 32.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.91125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 409.415
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 425.79,
    width: 31.29,
    height: 33.47,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 442.52500000000003
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 459.25,
    width: 31.29,
    height: 33.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 476.02
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 492.79,
    width: 31.29,
    height: 33.58,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 509.58000000000004
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 526.37,
    width: 31.29,
    height: 33.72,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.91125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 543.23
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 560.09,
    width: 31.29,
    height: 34.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.129
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 577.13
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 594.17,
    width: 31.29,
    height: 34.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 611.26
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 628.35,
    width: 31.29,
    height: 35.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 645.965
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.94,
    y: 663.58,
    width: 31.29,
    height: 36.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 29.585,
    y: 681.7900000000001
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 24.54,
    width: 31.36,
    height: 36.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.91,
    y: 42.84
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.58,
    y: 24.54,
    width: 31.53,
    height: 36.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.306
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 92.345,
    y: 42.84
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.12,
    y: 24.54,
    width: 31.75,
    height: 36.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.291666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.995,
    y: 42.84
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.87,
    y: 24.54,
    width: 31.83,
    height: 36.6,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.97875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.785,
    y: 42.84
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.7,
    y: 24.54,
    width: 32.54,
    height: 36.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.423333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.97,
    y: 42.84
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.23,
    y: 24.54,
    width: 33.62,
    height: 36.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.723999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.04,
    y: 42.84
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: 24.54,
    width: 34.1,
    height: 36.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.9,
    y: 42.84
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.95,
    y: 24.54,
    width: 34.23,
    height: 36.6,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.845999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.065,
    y: 42.84
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.18,
    y: 24.54,
    width: 34.56,
    height: 36.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.912000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.46000000000004,
    y: 42.84
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.74,
    y: 24.54,
    width: 38,
    height: 36.6,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.74,
    y: 42.84
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.74,
    y: 24.54,
    width: 38.15,
    height: 36.6,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.815,
    y: 42.84
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.9,
    y: 24.54,
    width: 39.72,
    height: 36.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.76,
    y: 42.84
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 456.61,
    y: 24.54,
    width: 39.76,
    height: 36.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.49,
    y: 42.84
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 496.38,
    y: 24.54,
    width: 40.01,
    height: 36.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.385,
    y: 42.84
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.38,
    y: 24.54,
    width: 40.02,
    height: 36.6,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.228571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.39,
    y: 42.84
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.4,
    y: 24.54,
    width: 40.74,
    height: 36.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.77,
    y: 42.84
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.15,
    y: 24.54,
    width: 41.23,
    height: 36.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.765,
    y: 42.84
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 658.37,
    y: 24.54,
    width: 41.63,
    height: 36.6,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.228571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.1850000000001,
    y: 42.84
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 61.14,
    width: 41.53,
    height: 36.72,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.343999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 79.5
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 97.86,
    width: 41.53,
    height: 36.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 116.255
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 134.65,
    width: 41.53,
    height: 37.95,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 153.625
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 172.6,
    width: 41.53,
    height: 37.96,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 191.57999999999998
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 210.56,
    width: 41.53,
    height: 38.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.6025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 229.765
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 248.98,
    width: 41.53,
    height: 39,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 268.48
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 287.97,
    width: 41.53,
    height: 39.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 307.69500000000005
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 327.42,
    width: 41.53,
    height: 40.52,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.788571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 347.68
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 367.94,
    width: 41.53,
    height: 41.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 388.47
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 409,
    width: 41.53,
    height: 43.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.932857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 430.545
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 452.09,
    width: 41.53,
    height: 47.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 475.69
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 499.29,
    width: 41.53,
    height: 48.24,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.614444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 523.41
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 547.52,
    width: 41.53,
    height: 50.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.306000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 572.71
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 597.9,
    width: 41.53,
    height: 50.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.932857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 623.14
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.23,
    y: 648.38,
    width: 41.53,
    height: 51.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.995,
    y: 674.1899999999999
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 61.14,
    width: 44.27,
    height: 50.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.324285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.89500000000001,
    y: 86.305
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.02,
    y: 61.14,
    width: 46.15,
    height: 50.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.691666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.095,
    y: 86.305
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.17,
    y: 61.14,
    width: 46.82,
    height: 50.33,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.803333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.57999999999998,
    y: 86.305
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.99,
    y: 61.14,
    width: 49.06,
    height: 50.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.176666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.52,
    y: 86.305
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.05,
    y: 61.14,
    width: 57.2,
    height: 50.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.388333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 301.65000000000003,
    y: 86.305
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.25,
    y: 61.14,
    width: 58.53,
    height: 50.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.065999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.515,
    y: 86.305
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.78,
    y: 61.14,
    width: 58.63,
    height: 50.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 418.09499999999997,
    y: 86.305
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.41,
    y: 61.14,
    width: 58.85,
    height: 50.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.29125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.83500000000004,
    y: 86.305
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.25,
    y: 61.14,
    width: 61.49,
    height: 50.33,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.592222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.995,
    y: 86.305
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.75,
    y: 61.14,
    width: 63.53,
    height: 50.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.515,
    y: 86.305
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.28,
    y: 61.14,
    width: 68.72,
    height: 50.33,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.592222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.64,
    y: 86.305
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 111.46,
    width: 64.68,
    height: 55.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 139.315
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 167.17,
    width: 64.68,
    height: 57.1,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.157142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 195.72
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 224.27,
    width: 64.68,
    height: 57.5,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.583333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 253.02
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 281.77,
    width: 64.68,
    height: 62.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 313.10999999999996
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 344.45,
    width: 64.68,
    height: 63.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 376.265
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 408.08,
    width: 64.68,
    height: 67.73,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.085
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 441.945
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 475.81,
    width: 64.68,
    height: 70.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 510.945
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 546.08,
    width: 64.68,
    height: 76.5,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.780000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 584.33
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.76,
    y: 622.57,
    width: 64.68,
    height: 77.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.780000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.10000000000001,
    y: 661.2850000000001
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 111.46,
    width: 63.11,
    height: 79.85,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.518333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.985,
    y: 151.385
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.54,
    y: 111.46,
    width: 66.6,
    height: 79.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 247.83999999999997,
    y: 151.385
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.14,
    y: 111.46,
    width: 66.89,
    height: 79.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.585,
    y: 151.385
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.03,
    y: 111.46,
    width: 84.85,
    height: 79.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.407142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.455,
    y: 151.385
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.88,
    y: 111.46,
    width: 86.85,
    height: 79.85,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.305,
    y: 151.385
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.73,
    y: 111.46,
    width: 88.38,
    height: 79.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.407142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.9200000000001,
    y: 151.385
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.11,
    y: 111.46,
    width: 91.89,
    height: 79.85,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.407142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 654.0550000000001,
    y: 151.385
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 191.31,
    width: 96.54,
    height: 78.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.001666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 230.315
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 269.32,
    width: 96.54,
    height: 81.75,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.21875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 310.195
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 351.07,
    width: 96.54,
    height: 81.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 391.99
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 432.92,
    width: 96.54,
    height: 86.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.83875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 476.27500000000003
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 519.63,
    width: 96.54,
    height: 88.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 563.83
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.43,
    y: 608.02,
    width: 96.54,
    height: 91.98,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.70000000000002,
    y: 654.01
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 191.31,
    width: 101.96,
    height: 108.03,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.565714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.95,
    y: 245.325
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.93,
    y: 191.31,
    width: 111.6,
    height: 108.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.606
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.73,
    y: 245.325
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.53,
    y: 191.31,
    width: 117.37,
    height: 108.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.432857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.2149999999999,
    y: 245.325
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.9,
    y: 191.31,
    width: 121.1,
    height: 108.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.432857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.4499999999999,
    y: 245.325
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 299.34,
    width: 126.15,
    height: 112.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.0675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.045,
    y: 355.60999999999996
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.97,
    y: 411.88,
    width: 126.15,
    height: 288.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.025000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.045,
    y: 555.94
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.12,
    y: 299.34,
    width: 158.84,
    height: 243.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 39.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.54,
    y: 420.89
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.96,
    y: 299.34,
    width: 167.04,
    height: 243.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.48,
    y: 420.89
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.12,
    y: 542.44,
    width: 325.88,
    height: 157.56,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.06,
    y: 621.22
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2020);
export default __webpack_public_path__ + "static/media/2020.f0713e5356c810629f524f39b01cd4e8.svg";
export { ForwardRef as ReactComponent };